import { useLocation, useNavigate, useParams } from "react-router";
import { useEffect, useState } from "react";
import { getAppUrl } from "../../utils/defines";
import NewProjectWidget from "components/NewProjectWidget";
import Button from "components/shared/button";
import { usePopover } from "providers/PopoverProvider";
import { StickyElementOffset } from "components/shared/stickystuck";
import ProfilePicture from "components/ProfilePicture";
import { generateKey } from "utils/helpers";
import { useSalesNetwork } from "utils/hooks/useSalesNetworks";

interface NavigationItem {
  key: string;
  url?: string;
  icon?: React.ReactNode;
  secondIcon?: React.ReactNode;
  title?: string;
  component?: React.ReactNode;
  showTitle?: boolean;
  separator?: boolean;
}

interface NavigationLayoutProps {
  defaultPage: string;
  items: NavigationItem[] | any[];
  onItemClick?: (item: NavigationItem) => void;
  isSelected?: (item: NavigationItem, currentPage: string) => boolean;
  isMonCompte?: boolean;
}

export const NavigationLayout: React.FC<NavigationLayoutProps> = ({
  defaultPage,
  items,
  onItemClick,
  isSelected,
  isMonCompte
}) => {
  const { section } = useParams();
  const { isThermor } = useSalesNetwork();
  const location = useLocation();
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(defaultPage);
  const { open } = usePopover();
  const [isStickyButton, setIsStickyButton] = useState(false);

  useEffect(() => {
    if (section) {
      setCurrentPage(section ?? defaultPage);
    } else {
      items.map((i) => {
        if (getAppUrl(i.url) === location.pathname) {
          setCurrentPage(i.key);
        }
      })
    }
  }, [section, location, defaultPage, items]);

  const checkIsSelected = (item: NavigationItem) => {
    if (isSelected) {
      return isSelected(item, currentPage);
    }
    return item.key === currentPage;
  };

  const handleItemClick = (item: NavigationItem) => {
    
    if (onItemClick) {
      onItemClick(item);
    } else {
      setCurrentPage(item.key);
      navigate(getAppUrl(item.url));
    }
  };

  const sampleDropdown = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
    open({
      element: (e.target as any).closest("[data-popover-trigger-menu]"),
      content: <group
        data-length="autofit"
      >
        {items.map((item) => {
          return (
            <group
              key={item.key}
              data-contain=""
              data-shrink="no"
              //data-name="autoseparation"
              data-wrap="no"
              data-align="center"
              data-width="autofit"
              data-gap="20"
              {...(checkIsSelected(item) ? { "data-state": "selected" } : {})} // NOSONAR

            >
              <group data-name="autoseparation_separator" data-height="fit" data-length="5"></group>
              <group
                // data-height="fit" 
                data-length="autofit"
                data-cursor="pointer"
                data-align="center"
                data-height="50"
                data-space="10"
                data-gap="10"
                data-wrap="no"
                //data-radius="5"
                data-contain=""
                onClick={() => handleItemClick(item)}
              >
                <icon data-svg-size="16" data-svg-color="main">{item.icon}</icon>
                <text data-wrap="wrap">{item.title}</text>
                {item.secondIcon && <icon data-svg-size="16" data-svg-color="secondary">{item.secondIcon}</icon>}
              </group>
            </group>
          )
        })}
        <group
          key="newproject"
          data-contain=""
          data-shrink="no"
          //data-name="autoseparation"
          data-wrap="no"
          data-align="center"
          data-width="autofit"
          data-gap="20"
          data-space-bottom="20"
        >
          <group data-name="autoseparation_separator" data-height="fit" data-length="5"></group>
          <group
            // data-height="fit" 
            data-length="autofit"
            data-cursor="pointer"
            data-align="center"
            data-height="50"
            data-space="10"
            data-gap="10"
            data-wrap="no"
            //data-radius="5"
            data-contain=""
          >
            <NewProjectWidget />
          </group>
        </group>

      </group>,

    });
  };

  return (
    <>
      <group data-direction="column" data-align="center" data-height="autofit" data-adaptive="desktop">

        <group data-wrap="no" data-height="fit" data-max-length="1200" >
          <group
            data-space-vertical="20"
            data-gap="20"
            data-direction="column"
            data-fit="1"
            data-max-length="300"
          >

            <group className="group-fixed-top" data-gap="30">
              <group
                data-wrap="no"
                data-space-vertical="20"
                //
                // data-gap="5"
                data-direction="column"
                data-background="white"
                data-elevation="6"
                data-radius="15"
              >
                {isMonCompte && <ProfilePicture />}
                {/* to do upload component */}
                {items.map((item) => {
                  return (
                    item.separator ?
                      <group data-space-horizontal="20" key={generateKey()}><separator data-margin="none" data-horizontal=""></separator></group>
                      :
                      <group
                        key={generateKey()}
                        data-contain=""
                        data-shrink="no"
                        data-name="autoseparation"
                        data-wrap="no"
                        //data-align="center"
                        data-width="autofit"
                        data-gap="10"
                        {...(checkIsSelected(item) ? { "data-state": "selected" } : {})} // NOSONAR

                      >
                        <group data-name="autoseparation_separator" data-height="fit" data-length="5"></group>
                        <group
                          // data-height="fit" 
                          data-length="autofit"
                          data-cursor="pointer"
                          data-align="start"
                          data-min-height="40"
                          data-space="10"
                          data-gap="10"
                          data-wrap="no"
                          data-radius="5"
                          //data-contain=""
                          data-space-right="15"
                          onClick={() => handleItemClick(item)}
                        >
                          <icon data-svg-size="16" data-svg-color="main">{item.icon}</icon>
                          <text data-wrap="wrap" data-length="autofit">{item.title}</text>
                          {item.secondIcon && <group data-length="autofit" data-align="start"><space data-length="30" data-height="fit" /><icon data-space="2" data-svg-size="12" data-svg-color="secondary" >{item.secondIcon}</icon></group>}
                        </group>
                      </group>
                  )
                })}
              </group>
              <NewProjectWidget />
            </group>
          </group>

          <group data-space="20" data-length="autofit" data-gap="20" data-direction="column" >
            {items.find(i => i.key === currentPage)?.showTitle && (
              <group data-wrap="no" data-space-top="20" data-gap="20" data-max-length="1440">
                <group data-height="fit" data-length="5" 
                  {...(!isThermor ? {"data-background":"main"} : {})}
                  >
                  
                  </group>
                <group data-length="autofit">
                  <text data-color="main" data-text-size="40">
                    {items.find(i => i.key === currentPage)?.title}
                  </text>
                </group>
              </group>
            )}
            <group data-height="autofit">{items.find(i => i.key === currentPage)?.component}</group>
          </group>
        </group>


      </group>

      {items.find(i => i.key === currentPage)?.showTitleMobile && <group data-direction="column" data-align="center" data-height="autofit" data-adaptive="mobile">

        <group
          data-wrap="no"
          data-height="fit"
          data-max-length="1200"
          data-adaptive="mobile"
          

        >
          <group data-space="20" data-gap="20" data-direction="column"

          >
            <group>
              {items.find(i => i.key === currentPage)?.showTitle && (
                <group data-wrap="no" data-gap="20" data-max-length="1440">
                  <group data-height="fit" data-length="5" data-background="main"></group>
                  <group data-length="autofit">
                    <text data-color="main" data-text-size="25" data-wrap="wrap">
                      {items.find(i => i.key === currentPage)?.title}
                    </text>
                  </group>
                </group>
              )}
            </group>



          </group>
        </group>
      </group>}

      {!items.find(i => i.key === currentPage)?.showTitleMobile ?
        <>
          <group
            data-sticky="top"
            data-sticky-level="75"
            data-index="3"

          >
            <group data-direction="column" data-align="center" data-height="autofit" data-adaptive="mobile"
            >

              <group
                data-wrap="no"
                data-height="fit"
              >
                <group data-space="1" data-gap="20" data-direction="column">
                  <group
                    data-popover-trigger-menu
                    data-length="autofit"

                  >
                    <Button
                      secondary
                      large
                      fit
                      onClick={sampleDropdown}
                    >
                      <text data-text-align="left" data-length="autofit">{items.find(i => i.key === currentPage)?.title}</text>
                      <icon data-svg-size="48" data-svg-color="main">expand_more</icon>
                    </Button>
                  </group>

                </group>
              </group>
            </group>
          </group>
        </>
        :
        <StickyElementOffset
          offestTop={250}
          setIsSticky={setIsStickyButton}
          data-sticky="top"
          data-sticky-level="75"
          data-index="3"

        >
          <group data-direction="column" data-align="center" data-height="autofit" data-adaptive="mobile"
          >

            <group
              data-wrap="no"
              data-height="fit"
            >
              <group data-space={isStickyButton ? "1" : "20"} data-gap="20" data-direction="column">
                <group
                  data-popover-trigger-menu
                  data-length="autofit"

                >
                  <Button
                    secondary
                    large
                    fit
                    onClick={sampleDropdown}
                  >
                    <text data-text-align="left" data-length="autofit">{items.find(i => i.key === currentPage)?.title}</text>
                    <icon data-svg-size="48" data-svg-color="main">expand_more</icon>
                  </Button>
                </group>

              </group>
            </group>
          </group>
        </StickyElementOffset>

      }



      <group data-direction="column" data-adaptive="mobile" data-height="autofit">
        <group data-height="autofit">{items.find(i => i.key === currentPage)?.component}</group>
      </group>
    </>
  );
};